import { useContext } from "react";
import { Crosshair } from "lucide-react";
import { SidebarContext } from "../../../shared/context/SidebarContext";
import { ModalEventsTracking } from "./modals";
import { ContainerFilter, ContainerFlowCards, ContainerResumeCards, TableTracking } from ".";
import { TrackingContext } from "../context/TrackingContext";


export default function Main() {

    const { isOpen } = useContext(SidebarContext);
    const { isOpenModalEventsTracking } = useContext(TrackingContext);


    return (
        <div className="min-h-screen text-ink-1 flex relative z-0">
            <div className={`transition-all duration-300 ease-out-expo ${isOpen ? "lg:ml-64" : "sm:ml-16"} w-full max-w-full mb-16 sm:mb-0`}>

                <div className="px-5 sm:px-8 pt-8 pb-12 max-w-[1600px] mx-auto">

                    <header className="mb-8 animate-fade-in">
                        <div className="space-y-1 mb-6">
                            <div className="flex items-center gap-2">
                                <span className="h-1.5 w-1.5 rounded-full bg-positive-400 animate-glow-pulse" />
                                <span className="label-overline text-positive-400/80">Pixel ativo</span>
                            </div>
                            <h1 className="display-2 flex items-center gap-3">
                                Tracking
                                <Crosshair className="h-7 w-7 text-brand-400" strokeWidth={2.2} />
                            </h1>
                            <p className="text-ink-3 text-sm">
                                Visitantes, eventos e atribuição UTM consolidados em tempo real.
                            </p>
                        </div>
                        <ContainerFilter />
                    </header>

                    <ContainerFlowCards />
                    <ContainerResumeCards />
                    <TableTracking />

                    {isOpenModalEventsTracking && <ModalEventsTracking />}

                </div>
            </div>
        </div>
    );
}
